import { render } from "./CDHOffense.vue?vue&type=template&id=2698b691&scoped=true"
import script from "./CDHOffense.vue?vue&type=script&lang=js"
export * from "./CDHOffense.vue?vue&type=script&lang=js"

import "./CDHOffense.vue?vue&type=style&index=0&id=2698b691&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2698b691"]])

export default __exports__